import React, { useState, useContext } from "react";
import { withSnackbar } from "notistack";
import { useHistory } from "react-router";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import { NewPatientContext } from "../store/NewPatientContextProvider";
import { setNewPatient, setNewPatientIDNumber, setPatientToInit } from "../store/action-reducers";
import { getPatientByIdNum } from "../api/api";

const NavbarPatientSearcher = (props) => {
  const history = useHistory();
  const [identificationNumber, setIdentificationNumber] = useState("");
  const { newPatientDispatch } = useContext(NewPatientContext);

  const handleInputChange = (e) => setIdentificationNumber(e.target.value);

  const handleSearch = async (e) => {
    e.preventDefault();
    const currentRoute = window.location.href.split("/")[ window.location.href.split("/").length - 1]; 
           localStorage.setItem("REQUESTED_URL_PREV_USER_SEARCH", currentRoute);

    try {
      if (!identificationNumber) {
        throw { message: "Identification Number required" };
      }

      const [res, err] = await getPatientByIdNum(identificationNumber);

      if (res.data){
        newPatientDispatch(setNewPatient(res.data));
        setIdentificationNumber("")
        history.push("/study");
      }
      else {
        console.log("err", err.message);
        newPatientDispatch(setPatientToInit());
        newPatientDispatch(setNewPatientIDNumber(identificationNumber));
        setIdentificationNumber("")
        history.push("/patient");
      }
    } catch (err) {
      console.log(err.message);
      if (err.message.search("404")) {
        props.enqueueSnackbar("User not found", {
          preventDuplicate: true,
          variant: "warning",
        });
      } else {
        props.enqueueSnackbar(err.message, {
          preventDuplicate: true,
          variant: "warning",
        });
      }
      newPatientDispatch(setPatientToInit());
      newPatientDispatch(setNewPatientIDNumber(identificationNumber));
      setIdentificationNumber("")
      history.push("/patient");
    }
  };

  return (
    <form
      onSubmit={handleSearch}
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <TextField
        name="username"
        label="Patient ID / Passport number"
        type={"text"}
        sx={{ width: 280, color: "#fff" }}
        value={identificationNumber}
        onChange={handleInputChange}
        size="small"
      />

      <Button
        color="primary"
        variant="outlined"
        sx={{
          ml: 1,
          height: 40,
          color: "#fff",
          border: 1,
          borderColor: "rgba(225,225,225,0.5)",
          borderRadius: 0,
        }}
        onClick={handleSearch}
      >
        <SearchIcon sx={{ color: "#fff" }} />
      </Button>
    </form>
  );
};

export default withSnackbar(NavbarPatientSearcher);
